import { Flex } from "@chakra-ui/react";
import {
  Card,
  DateRangePicker,
  HeaderTable,
  Pagination,
  SearchInput,
  TableAdmin,
} from "@components";
import { PAGE_SIZE } from "@constants";
import { AdminContext } from "context";
import { EDateParam, EOrder } from "enums";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getUserList } from "services";
import { IPagable, ISortTable, IUserRes } from "types";
import { columnsUsers } from "./components";
import "./style.css";

export const UserList = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const pageParam = searchParams.get("page") || "1";
  const searchParam = searchParams.get("search") || "";
  const {
    filterDate,
    setIsFetching,
    isFetching,
    currentTimezone: { name, timezone },
  } = useContext(AdminContext);
  const [pageUsers, setPageUsers] = useState<IPagable<IUserRes[]>>();
  const [sortTable, setSortTable] = useState<ISortTable>({
    orderBy: "firstName",
    order: EOrder.DESC,
  });
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const { result: listTable }: { result: IUserRes[] } = pageUsers || {
    result: [],
  };

  useEffect(() => {
    (async () => {
      try {
        if (isNaN(parseInt(pageParam))) return navigate(`/admin/users`);
        setIsFetching(true);
        const currentParams = Object.fromEntries(searchParams.entries());
        const res = await getUserList(
          filterDate,
          decodeURIComponent(searchParam),
          parseInt(pageParam),
          sortTable,
          pageSize
        );
        setPageUsers(res);
        res?.pageCount < parseInt(pageParam) &&
          setSearchParams({ ...currentParams, page: "1" });
      } catch (err: any) {
        console.log("log-error --- ", err);
      } finally {
        setIsFetching(false);
      }
    })();
  }, [filterDate, searchParam, pageParam, sortTable, pageSize]);

  const handleSortUsers = (sort: ISortTable) => {
    if (!isFetching) {
      setSortTable(sort);
    }
  };

  return (
    <Card extra="w-full p-4 card-user-list">
      <HeaderTable
        title="User List"
        addonAfter={
          <Flex gap={4} wrap="wrap" justifyContent="start">
            <SearchInput />
            <DateRangePicker
              placeholder="Select created date"
              startParam={EDateParam.START}
              endParam={EDateParam.END}
            />
          </Flex>
        }
      />
      <div className="flex w-full flex-1 flex-col justify-between gap-4 overflow-y-hidden">
        <TableAdmin
          listTable={listTable}
          sortTable={sortTable}
          setSortTable={(sort) => handleSortUsers(sort)}
          columns={columnsUsers}
          pageSize={pageSize}
        />
        <Pagination<IUserRes>
          pageUsers={pageUsers}
          pageParam={pageParam}
          setPageSize={setPageSize}
        />
      </div>
    </Card>
  );
};
